import { Component, Input } from '@angular/core';

export type lomyTextSizes = 'p' | 'h1' | 'h1x2' | 'h1x4';

@Component({
  selector: 'app-lomy-logo',
  templateUrl: './lomy-logo.component.html',
  styleUrls: ['./lomy-logo.component.scss'],
})
export class LomyLogoComponent {
  @Input() size: lomyTextSizes = 'h1';

  public setSize() {
    return `text--${this.size}`;
  }
}
